import * as Yup from "yup";

export default () =>
  Yup.object().shape({
    user: Yup.string("Debe ser un string").required("Usuario es requerido"),
    password: Yup.string().required("Contraseña es requerida"),
  });
